import { Box, Tab, TabList, TabPanel, TabPanels, Tabs, useColorModeValue } from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { servicesData } from "../assets/services";
import { Service } from "../global/types";
import ServicesCard from "../components/ServicesCard";

export default function EconomyPage() {
    const [ecoGovernmentServicesArray, setEcoGovernmentServicesArray] = useState<Service[]>([]);
    const [ecoEuropeanServicesArray, setEcoEuropeanServicesArray] = useState<Service[]>([]);
    const [ecoInternationalServicesArray, setEcoInternationalServicesArray] = useState<Service[]>([]);
    const [ecoIndependentsServicesArray, setEcoIndependentsServicesArray] = useState<Service[]>([]);
    const [ecoBanksServicesArray, setEcoBanksServicesArray] = useState<Service[]>([]);

    const getEcoGovernmentServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΟικονοΚυβερνητικοί Οργανισμοί");

    const getEcoEuropeanServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΟικονοΕυρωπαϊκοί Οργανισμοί");

    const getEcoInternationalServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΟικονοΔιεθνείς Οργανισμοί");

    const getEcoIndependentsServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΟικονοΑνεξάρτητες Αρχές");

    const getEcoBanksServices = (): Service[] =>
        servicesData.filter((srv: Service) => srv.category === "ΟικονοΤράπεζες");

    useEffect(() => {
        const governmentList = getEcoGovernmentServices();
        setEcoGovernmentServicesArray(governmentList);
    }, []);

    useEffect(() => {
        const europeanList = getEcoEuropeanServices();
        setEcoEuropeanServicesArray(europeanList);
    }, []);

    useEffect(() => {
        const internationalList = getEcoInternationalServices();
        setEcoInternationalServicesArray(internationalList);
    }, []);

    useEffect(() => {
        const independentsList = getEcoIndependentsServices();
        setEcoIndependentsServicesArray(independentsList);
    }, []);

    useEffect(() => {
        const banksList = getEcoBanksServices();
        setEcoBanksServicesArray(banksList);
    }, []);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    const tabColor = useColorModeValue("primary", "light");

    return (
        <Box>
            <Tabs variant="enclosed" colorScheme={tabColor}>
                <TabList flex="1">
                    <Tab style={{ fontWeight: 'bold' }}>Κυβερνητικοί Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ευρωπαϊκοί Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Διεθνείς Οργανισμοί</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Ανεξάρτητες Αρχές</Tab>
                    <Tab style={{ fontWeight: 'bold' }}>Τράπεζες</Tab>
                </TabList>
                <TabPanels>
                    <TabPanel>
                        {ecoGovernmentServicesArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {ecoEuropeanServicesArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {ecoInternationalServicesArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {ecoIndependentsServicesArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                    <TabPanel>
                        {ecoBanksServicesArray.map((srv: Service) => (
                            <ServicesCard inputService={srv} key={srv.title} />
                        ))}
                    </TabPanel>
                </TabPanels>
            </Tabs>
        </Box>
    );
}